import { render, staticRenderFns } from "./dice-launcher.vue?vue&type=template&id=24d65f0a&scoped=true"
import script from "./dice-launcher.vue?vue&type=script&lang=js"
export * from "./dice-launcher.vue?vue&type=script&lang=js"
import style0 from "./dice-launcher.vue?vue&type=style&index=0&id=24d65f0a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d65f0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d65f0a')) {
      api.createRecord('24d65f0a', component.options)
    } else {
      api.reload('24d65f0a', component.options)
    }
    module.hot.accept("./dice-launcher.vue?vue&type=template&id=24d65f0a&scoped=true", function () {
      api.rerender('24d65f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/dice-launcher.vue"
export default component.exports